import Swiper from 'swiper';
import Cookies from 'js-cookie';

import { breakpoints } from '../components/breakpoints';

export default function units() {
  if (!$('.block.units').length) {
    return;
  }

  let baseUrl = wordpress.homeurl;
  baseUrl += baseUrl.endsWith('/') ? 'plans/' : '/plans/';

  const sels = {
    header: '.site-header',
    block: '.block.units',
    form: '.block.units form',
    images: '.block.units .units__images',
    swiper: '.block.units .swiper-container',
    list: '.block.units .units__list__units',
    units: '.block.units .units__list__unit',
    filters: '.block.units .units__filters',
    back: '.block.units .units__images__back',
    radioPhase: '.block.units input[name="phase"]',
    radioLabels: '.block.units .units__type label',
    selectFloor: '.block.units select[name="floor"]',
    selectSize: '.block.units select[name="size"]',
    selectRooms: '.block.units select[name="rooms"]',
    svgBulles: '.block.units svg [data-bulle-phase]',
    svgPhases: '.block.units svg [data-phase]',
    svgFloors: '.block.units svg [class^="etage-numero"], .block.units svg [data-floor]',
    svgUnits: '.block.units svg [class^="unite-hover"]',
    svgNumbers: '.block.units svg [class^="unite-numero"]',
  };

  let search = {
    phase: getSearch('phase'),
    floor: getSearch('floor'),
    size: getSearch('size'),
    rooms: getSearch('rooms'),
  };

  let formRequest = {};

  function getSearch(param, defaultValue = '') {
    let data = window.location.href.replace(baseUrl, '').split('/');
    let value = '';
    $.each(data, function (index, field) {
      field = field.split('--');
      if (field[0] === param) {
        value = field[1];
      }
    });

    if (!value && defaultValue) {
      value = defaultValue;
    }

    return value;
  }

  /**
   * Sync search data and form on url
   */
  function syncSearchAndForm() {
    search.phase = getSearch('phase');
    search.floor = getSearch('floor');
    search.size = getSearch('size');
    search.rooms = getSearch('rooms');

    $(sels.radioLabels).removeClass('selected');
    $(sels.radioPhase).prop('checked', false);
    $(sels.radioPhase + `[value="${search.phase}"]`)
      .prop('checked', true)
      .closest('label')
      .addClass('selected');

    populateFloorsDropdown();
    populateRoomsDropdown();
    populateSizesDropdown();

    toggleFilters();

    $(sels.selectFloor).val(search.floor);
    $(sels.selectSize).val(search.size);
    $(sels.selectRooms).val(search.rooms);
  }

  /**
   * Search units
   */
  function doSearch() {
    if (typeof formRequest.abort === 'function') {
      formRequest.abort();
    }

    //Save search url in cookies
    Cookies.set('back-to-plans', window.location.href);

    //Submit ajax request
    $(sels.block).addClass('units--loading');

    //Units reset
    unitsReset();

    //Scroll to top of block
    $('body, html')
      .clearQueue()
      .animate(
        {
          scrollTop: $(sels.block).offset().top + 5 + 'px',
        },
        250
      );

    //Ajax request
    formRequest = $.post(
      wordpress.ajaxurl,
      {
        action: 'get_units',
        lang: wordpress.lang,
        search: search,
      },
      function (result) {
        $(sels.block).removeClass('units--loading');
        $(sels.list).html(result);
        resizeImages();
        unitsMaybeUnavailable();
      }
    );
  }

  /**
   * Search units on state change
   */
  $(window).bind('statechange', function () {
    syncSearchAndForm();
    doSearch();
    changeImage();
  });

  function changeUrl() {
    let url = baseUrl;
    $.each(search, function (searchTerm, value) {
      if (value) {
        url += `${searchTerm}--${value}/`;
      }
    });
    History.pushState(null, document.title, url);
  }

  /**
   * Swiper
   */
  const swiper = new Swiper(sels.swiper, {
    effect: 'fade',
    autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
  });

  function swiperGoTo(term) {
    const slideIndex = $(sels.swiper).find(`.swiper-slide[data-term="${term}"]`).attr('data-index');
    swiper.slideTo(slideIndex);
  }

  /**
   * Changing floor image
   */
  function changeImage() {
    if (search.floor) {
      swiperGoTo(search.floor);
    } else if (search.phase) {
      swiperGoTo(search.phase);
    } else {
      swiper.slideTo(0);
    }
  }

  /**
   * Populate floors dropdown
   */
  function populateFloorsDropdown() {
    $(sels.selectFloor + ' option:nth-child(n+2)').remove();
    $.each(wordpress.floors, function (index, floor) {
      if (floor.parent.slug === search.phase) {
        $(sels.selectFloor).append(`<option value="${floor.slug}">${floor.name}</option>`);
      }
    });
  }

  /**
   * Populate rooms dropdown
   */
  function populateRoomsDropdown() {
    $(sels.selectRooms + ' option:nth-child(n+2)').remove();
    $.each(wordpress.rooms[search.phase], function (rooms, name) {
      $(sels.selectRooms).append(`<option value="${rooms}">${name}</option>`);
    });
  }

  /**
   * Populate sizes dropdown
   */
  function populateSizesDropdown() {
    $(sels.selectSize + ' option:nth-child(n+2)').remove();
    $.each(wordpress.sizes[search.phase], function (size, name) {
      $(sels.selectSize).append(`<option value="${size}">${name}</option>`);
    });
  }

  /**
   * Toggle Filters
   */
  function toggleFilters() {
    if ($(sels.radioPhase + ':checked').attr('data-show-filters') === '1') {
      $(sels.filters).slideDown();
    } else {
      $(sels.filters).slideUp();
    }
  }

  /**
   * Phase change
   */
  $(sels.radioPhase).on('change', function () {
    search.phase = $(this).val();
    search.size = '';
    search.floor = '';
    search.rooms = '';
    changeUrl();
  });

  /**
   * Floor, Size, Rooms Change
   */
  $(sels.selectSize + ', ' + sels.selectFloor + ', ' + sels.selectRooms).on('change', function () {
    search[$(this).attr('name')] = $(this).val();
    changeUrl();
  });

  /**
   * Button "Retour au plan d'ensemble"
   */
  $(document).on('click', sels.back, function (e) {
    e.preventDefault();

    if (search.phase === 'maisons-de-ville' || search.phase === 'townhouses') {
      search.phase = '';
    } else if (!search.floor) {
      search.phase = '';
    }

    search.size = '';
    search.floor = '';
    search.rooms = '';

    changeUrl();
  });

  /**
   * Hide header when scrolling units
   */
  function maybeHideHeader() {
    const scroll = $(window).scrollTop();
    const blockPosition = $(sels.block).offset().top;
    if (scroll > blockPosition) {
      $(sels.header).addClass('force-hide');
    } else {
      $(sels.header).removeClass('force-hide');
    }
  }

  $(window).scroll(function () {
    maybeHideHeader();
  });

  /**
   * Position images on scroll and resize
   */
  function resizeImages() {
    const windowHeight = $(window).height();

    //Resize
    $('.units__images__image__content__inner').each(function () {
      let padding = parseInt($(this).css('padding-top')) + parseInt($(this).css('padding-bottom'));

      let top = parseInt($('.units__images__inner').css('top'));

      let textHeight = $(this).closest('.units__images__image').find('.units__images__image__text').outerHeight(true);

      let availableHeight = windowHeight - padding - top - textHeight - 80;
      availableHeight = Math.max(100, availableHeight);

      $(this)
        .find('svg')
        .css('max-height', availableHeight + 'px');
      $(this).find('svg').css('width', 'auto');
      $(this).find('svg').css('max-width', '100%');

      $(this)
        .find('img')
        .css('max-height', availableHeight + 'px');
      $(this).find('img').css('width', 'auto');
      $(this).find('img').css('max-width', '100%');

      swiper.update();
    });
  }

  $(window).resize(function () {
    resizeImages();
  });
  resizeImages();

  /**
   * On click svg phase and bulles
   */
  $(document).on('click', sels.svgPhases, function () {
    search.phase = $(this).attr('data-phase');
    changeUrl();
  });

  $(document).on('click', sels.svgBulles, function () {
    search.phase = $(this).attr('data-bulle-phase');
    changeUrl();
  });

  /**
   * On hover bulles, highlight phase
   */
  $(document).on('mouseover', sels.svgBulles, function () {
    const phase = $(this).attr('data-bulle-phase');
    $(`${sels.svgPhases}[data-phase="${phase}"]`).addClass('hover');
  });

  $(document).on('mouseleave', sels.svgBulles, function () {
    const phase = $(this).attr('data-bulle-phase');
    $(`${sels.svgPhases}[data-phase="${phase}"]`).removeClass('hover');
  });

  /**
   * On click svg floor
   */
  $(document).on('click', sels.svgFloors, function () {
    const attr = $(this).attr('data-term') || $(this).attr('data-floor');
    const floors = attr.split('|');
    search.floor = wordpress.lang === 'fr' ? floors[0] : floors[1];
    changeUrl();
  });

  $(`${sels.svgUnits}, ${sels.svgNumbers}`).each(function () {
    const unitNumber = $(this).attr('data-css-id').replace(/\D+/g, '');
    console.log(unitNumber);
    console.log($(this)); // logs the jQuery object
    $(this).attr('data-unit-number', unitNumber);
  });

  /**
   * On click svg unit redirects to single unit page
   */
  $(document).on('click', sels.svgUnits, function () {
    const number = $(this).attr('data-unit-number');
    $(`${sels.units}[data-unit-number="${number}"]`).click();
  });

  /**
   * On hover list highlight svg
   */
  $(document).on('mouseover', sels.units, function () {
    const number = $(this).attr('data-unit-number');
    $(`${sels.svgUnits}[data-unit-number="${number}"]`).addClass('is-current-unit');
  });

  $(document).on('mouseleave', sels.units, function () {
    const number = $(this).attr('data-unit-number');
    $(`${sels.svgUnits}[data-unit-number="${number}"]`).removeClass('is-current-unit');
  });

  /**
   * On hover svg highlight list and scroll to element
   */
  $(document).on('mouseover', sels.svgUnits + ':not(.unavailable)', function () {
    const number = $(this).attr('data-unit-number');
    const $listUnit = $(`${sels.units}[data-unit-number="${number}"]`);

    $listUnit.addClass('is-current-unit');

    //Check if unit is in viewport
    const unitHeight = $listUnit.outerHeight();
    const unitTop = $listUnit.offset().top;
    const unitBottom = unitTop + unitHeight;

    const screenHeight = $(window).innerHeight();
    const screenTop = $(window).scrollTop();
    const screenBottom = screenTop + screenHeight;

    const visible = screenBottom > unitBottom && screenTop < unitTop;
    let scrollTo = 0;

    const footerTop = $('footer').offset().top;
    const footerVisible = screenBottom > footerTop;

    //Not in viewport, scroll until visible
    // if (!visible && !footerVisible) {
    //   if (unitTop < screenTop) {
    //     //Unit is higher in page
    //     scrollTo = unitTop - 80;
    //   } else {
    //     //Unit is lower in page
    //     scrollTo = unitBottom - screenHeight + 20;
    //   }
    //
    //   $('body, html')
    //     .clearQueue()
    //     .animate(
    //       {
    //         scrollTop: scrollTo + 'px',
    //       },
    //       250
    //     );
    // }
  });

  /**
   * On hover out remove class
   */
  $(document).on('mouseleave', sels.svgUnits, function () {
    const number = $(this).attr('data-unit-number');
    $(`${sels.units}[data-unit-number="${number}"]`).removeClass('is-current-unit');
  });

  /**
   * Units reset
   */
  function unitsReset() {
    $(sels.units).removeClass('is-current-unit');
    $(sels.svgUnits).removeClass('is-current-unit unavailable');
    $(sels.svgNumbers).removeClass('unavailable');
  }

  function unitsMaybeUnavailable() {
    $(`${sels.svgUnits}, ${sels.svgNumbers}`).each(function () {
      const unitNumber = $(this).attr('data-unit-number');
      if ($(`${sels.units}[data-unit-number="${unitNumber}"]`).length === 0) {
        $(this).addClass('unavailable');
      }
    });
  }

  /**
   * Page init
   */
  syncSearchAndForm();
  doSearch();
  changeImage();
}
